import React from 'react';
import { X } from 'lucide-react';
import CustomLoader from '../../../../shared/components/ui/CustomLoader';
import './StageConfirmationModal.css';

/**
 * Modal component for confirming stage transitions (Accept, Reject, Reassign)
 */
const StageConfirmationModal = ({
    isOpen,
    onClose,
    type,
    notes,
    setNotes,
    error,
    setError,
    onConfirm,
    isUpdating
}) => {
    if (!isOpen) return null;

    const getTitle = () => {
        if (type === 'Accept') return 'Accept Proposal';
        if (type === 'Reassign') return 'Reassign Proposal';
        return 'Reject Proposal';
    };

    const getSubtitle = () => {
        const action = type === 'Accept' ? 'acceptance' : (type === 'Reassign' ? 'reassignment' : 'rejection');
        return `Add a note about the ${action} and next steps.`;
    };

    const getPlaceholder = () => {
        if (type === 'Accept') return "Acceptance details and next steps...";
        if (type === 'Reassign') return "Add comments or feedback for the team member...";
        return "Reason for rejection...";
    };

    return (
        <div className="custom-modal-overlay">
            <div className="stage-modal-content">
                <div className="stage-modal-header">
                    <div className="stage-modal-title-row">
                        <h3>{getTitle()}</h3>
                        <button className="stage-modal-close-x" onClick={onClose}>
                            <X size={18} />
                        </button>
                    </div>
                    <p className="stage-modal-subtitle">{getSubtitle()}</p>
                </div>

                <div className="stage-modal-body">
                    <textarea
                        className={`stage-modal-notes ${error ? 'error-border' : ''}`}
                        placeholder={getPlaceholder()}
                        value={notes}
                        onChange={(e) => {
                            setNotes(e.target.value);
                            if (e.target.value.trim().length >= 5) setError("");
                        }}
                        autoFocus
                    />
                    {error && <p className="modal-validation-error">{error}</p>}
                </div>

                <div className="stage-modal-actions">
                    <button
                        className="stage-modal-cancel"
                        onClick={onClose}
                        disabled={isUpdating}
                    >
                        Cancel
                    </button>
                    <button
                        className={`stage-modal-confirm ${type === 'Accept' ? 'accept-color' : 'reject-color'}`}
                        onClick={onConfirm}
                        disabled={isUpdating || (notes || '').trim().length < 5}
                    >
                        {isUpdating ? <CustomLoader className="spin" size={16} /> : (type === 'Reassign' ? 'Reassign' : `Confirm ${type}`)}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StageConfirmationModal;
